<div (dblclick)="modalDirective.modalExpand()"
     class="moved panel-heading d-flex justify-content-between align-items-center panel-theme-{{theme}}">
  <div class="moved modal-title pull-left">
    <span class="moved icon-title"><i-feather [name]="icon"></i-feather></span>
    <span class="moved text-title">{{title}}</span>
  </div>
  <div class="panel-heading-btn">
    <button *ngIf="minimized" (click)="minimize()" [class.rotate-180]="modalDirective?.isMinimize"
            class="btn btn-xs btn-ico btn-warning rounded-circle">
      <i-feather name="chevron-down"></i-feather>
    </button>
    <button *ngIf="expand" (click)="modalDirective.modalExpand()" class="btn btn-xs btn-ico btn-success rounded-circle">
      <i-feather name="maximize"></i-feather>
    </button>
    <button (click)="bsModalRef.hide()" class="btn btn-xs btn-ico btn-danger rounded-circle">
      <i-feather name="x"></i-feather>
    </button>
  </div>
</div>
